import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/stylesheets/tailwind.css";
import { createPinia } from "pinia";
import posthogPlugin from "../plugins/posthog";
import piniaPersistedState from "pinia-plugin-persistedstate";
import "./assets/stylesheets/global.css";
import { setupApolloClient } from "../apollo";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import { Frontegg } from "@frontegg/vue";
import { isPublicRoute } from "./utils/routeUtils";
import { loadProduktlyIfApplicable } from "./utils/loadProduktly";
import { setupPosthogSessionReplay } from "../plugins/posthog-session-replay";
// oidc-client-ts (used in cognitoSignIn / CognitoCallbackView) needs no
// global configure step — the UserManager is self-contained in oidc.ts.
import { useCognitoAuth } from "@/cognito/cognito.config";

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPersistedState);

// Only initialize Frontegg for non-public routes
if (!useCognitoAuth) {
  const isPublic = isPublicRoute();
  if (!isPublic) {
    loadProduktlyIfApplicable();
    app.use(Frontegg, {
      contextOptions: {
        baseUrl: process.env.VUE_APP_FRONTEGG_BASE_URL,
        clientId: process.env.VUE_APP_FRONTEGG_CLIENT_ID,
        appId: process.env.VUE_APP_FRONTEGG_APP_ID,
      },
      authOptions: {
        redirectUri: `${process.env.VUE_APP_BASE_URL}/oauth/callback`,
        keepSessionAlive: true,
      },
      hostedLoginBox: true,
      router,
    });
  }
}

app.use(pinia);
app.use(router);
app.use(posthogPlugin);
app.use(VCalendar, {});
setupApolloClient();
setupPosthogSessionReplay(router);
app.mount("#app");
